import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { toast } from '../components/Toast';
import { getErrorMsg } from '../services/error';

const queryCache = new QueryCache({
  onError: (error) => toast.error(getErrorMsg(error)),
});

const queryClient = new QueryClient({
  queryCache,
});

export function QueryProvider({ children }: React.PropsWithChildren) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
